export const CURRENT_MILESTONE_TEST_ID = 'CurrentMilestone';
export const CURRENT_MILESTONE_ICON_TEST_ID = 'CurrentMilestoneIcon';
export const CURRENT_MILESTONE_NAME_TEST_ID = 'CurrentMilestoneName';
